import { useMatches } from 'react-router'

import {
  MissingResourceIdInRouteError,
  ResourceType,
} from '@/errors/route/missing-resource-id'
import { useQueryParams } from '@/hooks/use-query-params'

export function useRequiredCompanyIdInRoute(): string {
  const matches = useMatches()

  const companyIdFromPath = matches[matches.length - 1]?.params.companyId

  const { getQueryParams } = useQueryParams()
  const { companyId: companyIdFromQuery } = getQueryParams()

  const companyId = companyIdFromPath || companyIdFromQuery

  if (!companyId) {
    throw new MissingResourceIdInRouteError(
      'Missing company ID in route.',
      ResourceType.COMPANY_ID,
    )
  }

  return companyId
}
